import { Navigate } from "react-router-dom";
import Error from "../page/error";
import UnAuthorize from "../page/unAuthorize";
import LogIn from "../page/user/login";
import Registration from "../page/user/Registration";
import AppLayout from "../component/layout/AppLayout";
import Dashboard from "../page/app/dashboard";
import { appRoot } from "./constant/CONSTANTS";
import ForgetPassword from "../page/user/Registration/forgetPass";
import Users from "../page/app/users";
import UserDetail from "../page/app/users/user-detail";
import DeviceType from "../page/app/device";
import Pets from "../page/app/pet";
import Feedback from "../page/app/feedback";
import Config from "../page/app/config";
import PetDetails from "../page/app/pet/pet-details";
import Notification from "../page/app/notification";
import BenchMark from "../page/app/benchmark";
import BenchMarkActivity from "../page/app/benchmark/activity";
import Plan from "../page/app/plans";
import SubPlans from "../page/app/plans/subPlan";
import FeedBackDetail from "../page/app/feedback/FeedBack-Detail";
import ModeFeedback from "../page/app/mode-feedback";
import ModeFeedbackDetails from "../page/app/mode-feedback/modeFeedbackDetails";
import PetModeFeedback from "../page/app/pet/tabs/petModeFeedback";
import ErrorLog from "../page/app/device/tabs/tabs/error-log";
import Feeder from "../page/app/feeder";
import FeederErrorLogs from "../page/app/feeder/tabs";
import RoleAndAccess from "../page/app/role-and-access";
import {
  AiOutlineUser,
  AiOutlineSetting
} from "react-icons/ai";
import { GiDogBowl } from "react-icons/gi";
import { HiOutlineDeviceMobile, HiOutlinePresentationChartLine } from "react-icons/hi";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { FaBriefcaseMedical, FaDog, FaHandHoldingDollar } from "react-icons/fa6";
import { IoMdNotificationsOutline } from "react-icons/io";
import { GrLocation } from "react-icons/gr";
import { MdFeedback, MdFoodBank, MdOutlinePets } from "react-icons/md";
import { VscGraph, VscFeedback } from "react-icons/vsc";
import { ROLES } from "./functions";
import LocationHistory from "../page/app/location-history";
import PetDevice from "../page/app/pet-device";
import ResetPassword from "../page/user/Registration/reset-Password";
import { IoImageOutline } from "react-icons/io5";
import Banner from "../page/app/banner";
import Medicine from "../page/app/medicine";
import FoodCalorie from "../page/app/food-calorie";

export const ROUTES = {
  FORGOT_PASSWORD: "/forgot-password",
  DASHBOARD: "/analytics",
  USERS: "/users",
  USERS_DETAIL: "/users/:id",
  DEVICE: '/device',
  DEVICE_DETAIL: '/device/:deviceId',
  BANNER: '/banner',
  PETS: '/pets',
  PETS_DETAIL: '/pets/:id',
  PETS_DETAIL_MODE_FEEDBACK: '/pets/:id/:historyId',
  FEEDBACK: '/feedback',
  FEEDBACK_DETAIL: '/feedback/:id',
  MODE_FEEDBACK: '/mode-feedback',
  MODE_FEEDBACK_DETAIL: '/mode-feedback/:id',
  CONFIG: '/config',
  NOTIFICATION: '/notification',
  BENCHMARK: '/benchmark',
  BENCHMARK_ACTIVITY: '/benchmark/activity/:id',
  PLAN: '/plan',
  SUB_PLAN: '/plan/sub-plan/:id',
  FEEDER: '/feeder',
  FEEDER_ERROR_LOGS: '/feeder/:id',
  ROLE_AND_ACCESS: '/role-and-access',
  PET_DEVICE: '/pet-device',
  LOCATION_HISTORY: '/location-history',
  RESET_PASSWORD: '/reset-password/:token',
  MEDICINE: '/medicine',
  FOOD_CALORIES: '/food-calories',



};

export const role = localStorage.getItem('role')



const DefaultRoleRoutes = {
  'Admin': ROUTES.DASHBOARD,
  'Manufacturer': ROUTES.DEVICE,
  'ClientSupport': ROUTES.USERS,
}

export const LOGIN_ROUTES = [

  {
    index: true,
    element: <LogIn />,
  },

  {
    path: ROUTES.FORGOT_PASSWORD,
    element: <ForgetPassword />,
    errorElement: <Error />,
  },
  {
    path: ROUTES.RESET_PASSWORD,
    element: <ResetPassword />,
    errorElement: <Error />,
  },
];

const ALL_ROUTES = (appProps) => [
  ...LOGIN_ROUTES,

  {
    path: `${appRoot}`,
    element: <AppLayout {...appProps} />,
    Role: [
      ROLES.Admin,
      ROLES.Manufacturer,
      ROLES.ClientSupport,
    ],
    children: [
      {
        index: true,
        element: <Navigate to={`${appRoot}${DefaultRoleRoutes[role]}`} />,

      },
      {
        icon: <VscGraph />,
        label: "Analytics",
        path: `${appRoot}${ROUTES.DASHBOARD}`,
        element: <Dashboard {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        icon: <AiOutlineUser />,
        label: "Users",
        path: `${appRoot}${ROUTES.USERS}`,
        element: <Users {...appProps} />,
        Role: [
          ROLES.Admin,
          ROLES.ClientSupport,
        ],
      },
      {
        path: `${appRoot}${ROUTES.USERS_DETAIL}`,
        element: <UserDetail {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        icon: <HiOutlineUserGroup />,
        label: "Roll & Access",
        path: `${appRoot}${ROUTES.ROLE_AND_ACCESS}`,
        element: <RoleAndAccess {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },




      {
        icon: <FaDog />,
        label: "Pets",
        path: `${appRoot}${ROUTES.PETS}`,
        element: <Pets {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },

      {
        icon: <IoImageOutline />,
        label: "Banner",
        path: `${appRoot}${ROUTES.BANNER}`,
        element: <Banner {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        icon: <HiOutlinePresentationChartLine />,
        label: "Benchmark",
        path: `${appRoot}${ROUTES.BENCHMARK}`,
        element: <BenchMark {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        icon: <HiOutlineDeviceMobile />,
        label: "Device",
        path: `${appRoot}${ROUTES.DEVICE}`,
        element: <DeviceType {...appProps} />,
        Role: [
          ROLES.Admin,
          ROLES.Manufacturer,
        ],
      },
      {
        path: `${appRoot}${ROUTES.DEVICE_DETAIL}`,
        element: <ErrorLog {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },

      {
        icon: <MdOutlinePets />,
        label: "Pet's Device",
        path: `${appRoot}${ROUTES.PET_DEVICE}`,
        element: <PetDevice {...appProps} />,
        Role: [
          ROLES.Admin,
          ROLES.ClientSupport,
        ],
      },
      {
        path: `${appRoot}${ROUTES.BENCHMARK_ACTIVITY}`,
        element: <BenchMarkActivity {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        path: `${appRoot}${ROUTES.PETS_DETAIL}`,
        element: <PetDetails {...appProps} />,
        Role: [
          ROLES.Admin,
          ROLES.ClientSupport,
        ],
      },
      {
        path: `${appRoot}${ROUTES.PETS_DETAIL_MODE_FEEDBACK}`,
        element: <PetModeFeedback {...appProps} />,
        Role: [
          ROLES.Admin,

        ],
      },
      {
        icon: <MdFoodBank />,
        label: "Food Calories",
        path: `${appRoot}${ROUTES.FOOD_CALORIES}`,
        element: <FoodCalorie {...appProps} />,
        Role: [
          ROLES.Admin,
          ROLES.ClientSupport,
        ],
      },
      {
        icon: <GiDogBowl />,
        label: "Feeder",
        path: `${appRoot}${ROUTES.FEEDER}`,
        element: <Feeder {...appProps} />,
        Role: [
          ROLES.Admin,
          ROLES.Manufacturer,
        ],
      },
      {
        path: `${appRoot}${ROUTES.FEEDER_ERROR_LOGS}`,
        element: <FeederErrorLogs {...appProps} />,
        Role: [
          ROLES.Admin,
          ROLES.Manufacturer,
        ],
      },
      {
        icon: <GrLocation />,
        label: "Location History Access",
        path: `${appRoot}${ROUTES.LOCATION_HISTORY}`,
        element: <LocationHistory {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        icon: <FaHandHoldingDollar />,
        label: "Plan",
        path: `${appRoot}${ROUTES.PLAN}`,
        element: <Plan {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        path: `${appRoot}${ROUTES.SUB_PLAN}`,
        element: <SubPlans {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },

      {
        icon: <FaBriefcaseMedical />,
        label: "Medicine",
        path: `${appRoot}${ROUTES.MEDICINE}`,
        element: <Medicine {...appProps} />,
        Role: [
          ROLES.Admin,
          ROLES.ClientSupport,
        ],
      },
      {
        icon: <VscFeedback />,
        label: "Feedback",
        path: `${appRoot}${ROUTES.FEEDBACK}`,
        element: <Feedback {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        icon: <MdFeedback />,
        label: "Mode Feedback",
        path: `${appRoot}${ROUTES.MODE_FEEDBACK}`,
        element: <ModeFeedback {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        path: `${appRoot}${ROUTES.MODE_FEEDBACK_DETAIL}`,
        element: <ModeFeedbackDetails {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        path: `${appRoot}${ROUTES.FEEDBACK_DETAIL}`,
        element: <FeedBackDetail {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },

      {
        icon: <IoMdNotificationsOutline />,
        label: "Notification",
        path: `${appRoot}${ROUTES.NOTIFICATION}`,
        element: <Notification {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },
      {
        icon: <AiOutlineSetting />,
        label: "App Config",
        path: `${appRoot}${ROUTES.CONFIG}`,
        element: <Config {...appProps} />,
        Role: [
          ROLES.Admin,
        ],
      },


    ],
  },
  {
    path: "/error",
    element: <Error />,
  },
  {
    path: "/unAuthorize",
    element: <UnAuthorize />,
  },
  {
    path: "*",
    element: <Navigate to="/error" />,
  },
];

export default ALL_ROUTES;
